import React from "react";
import PropTypes from "prop-types";
import { Grid, CFontIcon } from "@appcues/component-library";

import MetricCard from "components/Common/Metric/MetricCard";
import CoolTip from "components/Common/CoolTip";

import { numberWithCommas } from "utils/textFormatting";
import QueryResults from "components/Common/QueryResults";
import GoalCard from "./GoalCard";

export const Scoreboard = ({ flowId, startTime, results }) => {
  const [
    {
      flow_users = 0,
      flows_shown = 0,
      flow_completed_users = 0,
      flows_completed = 0,
      flow_error_users = 0,
      flow_errors = 0
    }
  ] = results && results.length ? results : [{}];

  return (
    <Grid
      marginTop="1em"
      minItemWidths={[245, [1430, 200], [1250, 185], [1190, 260], [920, 185]]}
    >
      <MetricCard
        loaded={!!results}
        name="USERS"
        metric={flow_users}
        caption={`unique | ${numberWithCommas(flows_shown)} total`}
      />
      <MetricCard
        loaded={!!results}
        name="COMPLETION"
        metric={
          flow_users ? parseInt(100 * (flow_completed_users / flow_users)) : "-"
        }
        metricType={flow_users && "percentage"}
        caption={
          flows_shown
            ? `unique | ${
                flows_shown
                  ? parseInt(100 * (flows_completed / flows_shown)) + "% total"
                  : "-"
              }`
            : null
        }
      />
      <MetricCard
        loaded={!!results}
        name="ISSUES"
        metric={flow_error_users}
        caption={
          <CoolTip tip="When Appcues cannot display a step, due to a missing or incorrect selector.">
            unique | {numberWithCommas(flow_errors)} total
            <CFontIcon className="fas fa-info-circle" marginLeft={5} />
          </CoolTip>
        }
      />

      <GoalCard flowId={flowId} startTime={startTime} />
    </Grid>
  );
};

Scoreboard.propTypes = {
  flowId: PropTypes.string,
  startTime: PropTypes.string,
  results: PropTypes.arrayOf(
    PropTypes.shape({
      flow_users: PropTypes.number,
      flows_shown: PropTypes.number,
      flow_completed_users: PropTypes.number,
      flows_completed: PropTypes.number,
      flow_error_users: PropTypes.number,
      flow_errors: PropTypes.number
    })
  )
};

const ScoreboardWithAnalytics = ({ flowId, startTime }) => (
  <QueryResults
    query={{
      metrics: [
        "flow_users",
        "flows_shown",
        "flow_completed_users",
        "flows_completed",
        "flow_error_users",
        "flow_errors"
      ],
      conditions: [["flow_id", "==", flowId]],
      start_time: startTime
    }}
  >
    {results => (
      <Scoreboard results={results} flowId={flowId} startTime={startTime} />
    )}
  </QueryResults>
);

ScoreboardWithAnalytics.propTypes = {
  flowId: PropTypes.string,
  startTime: PropTypes.string
};

export default ScoreboardWithAnalytics;
